export const environment = {
  production: false,
  pocketbaseUrl: 'https://privat.klausurenkiste.de',
  turnstileSiteKey: '0x4AAAAAACXp04IivLtHxXmT'
};
